/* tslint:disable */

declare var Object: any;
export interface ConversationDeleteTrackerInterface {
  "sfdcId"?: string;
  "PgMO_Conversation__c": string;
  "Worker__c": string;
  "CreatedBy": string;
  "CurrencyIsoCode": string;
  "LastModifiedBy": string;
  "Name": string;
  "id"?: number;
}

export class ConversationDeleteTracker implements ConversationDeleteTrackerInterface {
  "sfdcId": string;
  "PgMO_Conversation__c": string;
  "Worker__c": string;
  "CreatedBy": string;
  "CurrencyIsoCode": string;
  "LastModifiedBy": string;
  "Name": string;
  "id": number;
  constructor(data?: ConversationDeleteTrackerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ConversationDeleteTracker`.
   */
  public static getModelName() {
    return "ConversationDeleteTracker";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ConversationDeleteTracker for dynamic purposes.
  **/
  public static factory(data: ConversationDeleteTrackerInterface): ConversationDeleteTracker{
    return new ConversationDeleteTracker(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ConversationDeleteTracker',
      plural: 'ConversationDeleteTrackers',
      path: 'ConversationDeleteTrackers',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "PgMO_Conversation__c": {
          name: 'PgMO_Conversation__c',
          type: 'string'
        },
        "Worker__c": {
          name: 'Worker__c',
          type: 'string'
        },
        "CreatedBy": {
          name: 'CreatedBy',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedBy": {
          name: 'LastModifiedBy',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
